import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-exam-shortlist',
  templateUrl: './exam-shortlist.component.html',
  styleUrls: ['./exam-shortlist.component.scss']
})
export class ExamShortlistComponent implements OnInit {

  career_type_for_exam = 1;

  showRecords;
  search;

  isLoading = false;
  isDataLoading = false;


  constructor() { }

  ngOnInit() {
  }

  demo() { }

  paginate(event) { }

  updateUIData() {

  }
}
